import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar } from "../primitives/Avatar";
import { RoleBadge } from "./RoleBadge";
export function UserChip({ user, className }) {
    return (_jsxs("div", { className: className, style: {
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            padding: "4px 10px 4px 4px",
            borderRadius: 999,
            background: "var(--surface-2)",
            border: "1px solid var(--border)",
        }, children: [_jsx(Avatar, { name: user.name, size: "sm" }), _jsx("span", { style: { fontSize: 12, fontWeight: 500, color: "var(--ink)" }, children: user.name }), _jsx(RoleBadge, { role: user.role })] }));
}
//# sourceMappingURL=UserChip.js.map